module.exports = __webpack_public_path__ + "static/img/qiangou.5ab5a885.png";